export interface IDonorShieldDirectCounts {
    pendingTransplantTotal,
    transplantedTotal
}